import { ADMIN_LINE_REQUESTS } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from './useHasCapability';

/**
 * Whether the current PSAP has the admin SMS (TTAdmin) capability enabled.
 */
function useIsAdminSmsEnabled(): boolean {
  return !!useHasCapability(ADMIN_LINE_REQUESTS).hasCapability;
}

export default useIsAdminSmsEnabled;
